import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/7_1.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Gdzie jest Tarszewo"
            question=""
            audio={audio}
            answers={{
                ans1: "Dalej",
            }}
            links={{
                link1: PAGES.p19,
            }}
            content={
                <div>
                    <ul>
                        <li>Gdzie jest Tarszewo? Daleko? – pytasz z myślą o noclegu u Emila.</li>
                        <li>Ach, Tarszewo… Na łąkach w stronę Warty. Tam też stoi nasz kantorat – uśmiecha się kantor.</li>
                        <li>Jeszcze jeden?</li>
                        <li>Jeden? A to dobre! Jest i w Tarszewie, i w Olchowie po drodze, największy w Łazińsku, ale są też w Anielewie, w Michalinowie… A w każdym kantoracie – kantor, taki jak ja – dodaje z dumą. – Pomagamy pastorowi Grossowi, no sam się nie wyrobi. I nabożeństwo, i modlitwę trzeba poprowadzić, no i dzieci uczyć, chociaż teraz, kiedy Piłsudski polskie szkoły powszechne wprowadził, to mniej na szczęście tego mamy… Przed wielką wojną to tylko u nas się dzieci uczyły…
                        </li>
                    </ul>
                </div>
            }
        />

    );
}